const toKebabCase = (value: string): string =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();

export const testId = (screen: string, element: string, index?: number | string): string => {
  const base = `${toKebabCase(screen)}-${toKebabCase(element)}`;
  return index !== undefined ? `${base}-${index}` : base;
};

export const screenTestId = (screen: string) => {
  return (element: string, index?: number | string): string => testId(screen, element, index);
};
